import React, { useState, useEffect } from "react";
import ApiService from "../../../services/apiService";
import "./NotificationSection.css";

const AllNotifications = () => {
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const dummyNotifications = [
    {
      id: 1,
      title: "Academic Calendar for Academic Year 2024-25",
      date: "2024-10-15",
      category: "EXAMINATION",
      link: "#",
    },
    {
      id: 2,
      title: "Tender Notice for Library Renovation Project",
      date: "2024-10-10",
      category: "TENDERS",
      link: "#",
    },
    {
      id: 3,
      title: "Circular: Guidelines for Student Admission Process",
      date: "2024-10-05",
      category: "CIRCULARS",
      link: "#",
    },
    {
      id: 4,
      title: "Press Release: University Rankings 2024",
      date: "2024-09-28",
      category: "PRESS NOTES",
      link: "#",
    },
    {
      id: 5,
      title: "Examination Schedule for Semester End Exams",
      date: "2024-09-25",
      category: "EXAMINATION",
      link: "#",
    },
  ];

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      setLoading(true);

      const response = await ApiService.getNotifications();

      console.log("Notification API:", response.data);

      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      setNotifications(data);
      setError(false);
    } catch (err) {
      console.error(err);
      setNotifications([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const source =
    error || notifications.length === 0
      ? dummyNotifications
      : notifications;

  const allNotifications = source.map((item) => ({
    id: item.id,

    title:
      typeof item.title === "object"
        ? item.title?.rendered
        : item.title ||

          item.post_title ||

          "Untitled Notification",

    date: item.date
      ? new Date(item.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "",

    type:
      item.category ||
      item.type ||
      item.notification_type ||
      "GENERAL",

    link:
      item.link ||
      item.pdf ||
      item.file ||
      item.guid?.rendered ||
      "#",
  }));

  const filterTypes = [
    "ALL",
    "TENDERS",
    "EXAMINATION",
    "CIRCULARS",
    "PRESS NOTES",
    "GENERAL",
  ];

  const filtered =
    activeFilter === "ALL"
      ? allNotifications
      : allNotifications.filter((n) => n.type === activeFilter);

  return (
    <section className="ray-notif-section">
      <div className="ray-notif-container">
        <div className="ray-notif-header">
          <h2>Notifications</h2>
        </div>

        <div className="ray-notif-filters">
          {filterTypes.map((filter) => (
            <button
              key={filter}
              className={`ray-filter-btn ${
                activeFilter === filter ? "active" : ""
              }`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="ray-notif-list">
          <div className="ray-notif-header">
            <span className="ray-notif-date-header">Date</span>
            <span className="ray-notif-title-header">Title</span>
            <span className="ray-notif-category-header">Category</span>
          </div>

          <div className="ray-notif-scrollable">
            {loading ? (
              <div className="ray-loading">
                Loading Notifications...
              </div>
            ) : filtered.length > 0 ? (
              filtered.map((notification) => (
                <div
                  className="ray-notif-item"
                  key={notification.id}
                >
                  <span className="ray-notif-date">
                    {notification.date}
                  </span>

                  <div className="ray-notif-content">
                    {notification.link !== "#" ? (
                      <a
                        href={notification.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ray-notif-title"
                      >
                        {notification.title}
                      </a>
                    ) : (
                      <span className="ray-notif-title">
                        {notification.title}
                      </span>
                    )}
                  </div>

                  <span className="ray-notif-category">
                    {notification.type}
                  </span>
                </div>
              ))
            ) : (
              <div className="ray-no-notif">
                No Notifications Found.
              </div>
            )}
          </div>
        </div>

        <div className="ray-view-all">
          <a
            href="/more/notifications"
            className="ray-view-btn"
          >
            View All Notifications
          </a>
        </div>
      </div>
    </section>
  );
};

export default AllNotifications;